var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "pb-1" },
    [
      _c("IngestionResultsLogDialog", { ref: "ingestionResultsDialog" }),
      _vm._v(" "),
      _c("Subheader", {
        staticClass: "pb-2",
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _c(
                    "v-toolbar-title",
                    [
                      _c("v-icon", { attrs: { medium: "" } }, [
                        _vm._v("event_note"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "headline" }, [
                        _vm._v(" " + _vm._s(_vm.title) + " "),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            _vm.supportsRefresh
              ? {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", loading: _vm.loading },
                          on: { click: _vm.refresh },
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-xs-center pt-5 pb-3" },
            [
              _c("v-progress-circular", {
                staticClass: "mx-auto",
                attrs: { size: "50", color: "info", indeterminate: "" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "my-3" }, [
                _vm._v("Loading import events"),
              ]),
            ],
            1
          )
        : _vm.error
        ? [
            _c("v-alert", { attrs: { type: "error", value: true } }, [
              _vm._v("Failed to load import events."),
            ]),
          ]
        : _vm._l(_vm.displayItems, function (indexId, j) {
            return _c("ImportCard", {
              key: `import-${j}`,
              attrs: { indexId: indexId },
              on: {
                "show:logs": function ($event) {
                  return _vm.showIngestionLogs(indexId)
                },
              },
            })
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }